module.exports = __webpack_public_path__ + "static/media/bouygues.0d55686b.png";